import React from 'react';
import format from 'date-fns/format';
import {centTo$} from '~/misc/formatMoney';
import vipShownameTransfer from '~/components/pages/vipShownameTransfer.js';

import css from './index.css';

const AccountInformation = (props) => {
  const showDate = (props.msg && props.msg.nextBillDate) ? format(props.msg.nextBillDate, 'DD/MM/YY') : null;

  return (<div className={css.infoWrap}>
    <ul className={css.left}>
      <li>Membership plan: <span className={css.colorBlue} >{props.msg ? vipShownameTransfer[props.msg.memberPlan.toLocaleLowerCase()] : ''}</span></li>
      <li>Member ID: <span className={css.colorBlue}>{props.msg ? props.msg.memberId : ''}</span></li>
      <li>Manage Seats: <span className={css.colorBlue}>{props.msg ? props.msg.manageUsers : ''}</span></li>
    </ul>
    <ul className={css.right}>
      <li>Next billing date: <span className={css.colorBlue}>{showDate}</span></li>
      <li>Billing cycle: <span className={css.colorBlue}>{props.msg ? props.msg.billCycle : ''}</span></li>
      <li>
        Current membership cost:{' '}
        <span className={css.colorBlue}>${props.msg ? centTo$(props.msg.currentCost) : ''}</span>
      </li>
    </ul>
  </div>);
};

export default AccountInformation;



// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/share/AccountInformation/index.js